import { Injectable } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebStorageService } from '../services/web-storage/web-storage-service';

@Injectable()
export class ChannelInterceptor implements HttpInterceptor {
  constructor(private webStorageService: WebStorageService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headerName = 'Channel';
    const headerValue = 'BoxDelivery';

    if (!request.headers.has(headerName)) {
      request = request.clone({ headers: request.headers.set(headerName, headerValue) });
    }

    return next.handle(request);
  }
}

export let ChannelInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ChannelInterceptor,
  multi: true
};
